import type { MouseEventHandler } from "react";

import type { Gender } from "@./cat-calculations";

import type { TIconKey, TImageProps } from "@/ui/components/primitives";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TCatOverview = {
  name: string;
  birthday: string;
  freshStatus: string;
  breed: string;
  gender: Gender;
  neuterStatus: string;
};

export type TCatOverviewCardProps = {
  cat: TCatOverview;
  image: TImageProps;
  editLabel: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TCatOverviewDetailProps = {
  icon: Extract<TIconKey, "cake" | "cat" | "mars" | "venus" | "circleSmall">;
  label: string;
  value: string;
};

/*-------------------------------------
|  Constants
-------------------------------------*/

export const CAT_GENDER_ICON_MAP: Record<Gender, Extract<TIconKey, "mars" | "venus" | "circleSmall">> = {
  BOY: "mars",
  GIRL: "venus",
  UNKNOWN: "circleSmall",
};
